module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SelectBindCardCodeView.js"));
	}, "SelectBindCardCodeView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SelectBindCardCodeView!./src/pages/Shop/WechatAuth/SelectBindCardCode/SelectBindCardCodeView.js
// module id = 1385
// module chunks = 418